import { module } from 'stereomodularjs';
import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';
import HotelDatepicker from "hotel-datepicker";


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const template = this.el.nextElementSibling;
        this.initVUE(template);
        template.remove();
    }

    initVUE(template) {
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
        template = template.innerHTML;
        const res = compileToFunctions(template);
        new Vue({
            el: this.el,
            data: {
                preaux: [],
                form: {
                    preau_id: null,
                    dateRange: {
                        start: null,
                        end: null
                    },
                    terms: false,
                    terms_date: null,
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    entreprise: '',
                    type: '',
                    other: '',
                    nb_adulte: null,
                    nb_enfant: null,
                    options: [],
                    optionsGlobal: [],
                    comments: ''
                },
                isSubmitting: false,
                dates: '',
                hdpkr: null,
                i18n: {
                    selected: 'Votre selection:',
                    night: 'Journée',
                    nights: 'Journées',
                    button: 'Fermer',
                    clearButton: 'Effacer',
                    submitButton: 'Valider',
                    'checkin-disabled': 'Check-in disabled',
                    'checkout-disabled': 'Check-out disabled',
                    'day-names-short': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                    'day-names': ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                    'month-names-short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    'month-names': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                    'error-more': 'Date range should not be more than 1 night',
                    'error-more-plural': 'Date range should not be more than %d nights',
                    'error-less': 'Date range should not be less than 1 night',
                    'error-less-plural': 'Date range should not be less than %d nights',
                    'info-more': 'Selectionnez une date',
                    'info-more-plural': 'Please select a date range of at least %d nights',
                    'info-range': 'Please select a date range between %d and %d nights',
                    'info-range-equal': 'Please select a date range of %d nights',
                    'info-default': 'Please select a date range',
                    'aria-application': 'Calendar',
                    'aria-selected-checkin': 'Selected as check-in date, %s',
                    'aria-selected-checkout': 'Selected as check-out date, %s',
                    'aria-selected': 'Selected, %s',
                    'aria-disabled': 'Not available, %s',
                    'aria-choose-checkin': 'Choose %s as your check-in date',
                    'aria-choose-checkout': 'Choose %s as your check-out date',
                    'aria-prev-month': 'Move backward to switch to the previous month',
                    'aria-next-month': 'Move forward to switch to the next month',
                    'aria-close-button': 'Close the datepicker',
                    'aria-clear-button': 'Clear the selected dates',
                    'aria-submit-button': 'Submit the form'
                }
            },
            methods: {
                showTerms(event){
                    let app = this;
                    if(this.form.preau_id === null){
                        alert('Veuillez sélectionner un préau');
                        return;
                    }

                    if(!this.preaux[this.form.preau_id].fields.reglements_web && !this.form.terms){
                        this.form.terms = 'true';
                        let datetime = new Date();
                        this.form.terms_date = datetime.toLocaleString('fr-CA', { timeZone: 'America/Toronto' });
                        return;
                    }

                    if(this.form.terms){
                        this.form.terms = false;
                        return;
                    }

                    classAdd(document.querySelector('html'),'is-overlay-active');

                    let terms_panel = document.querySelector('#js-terms');
                    terms_panel.innerHTML = this.preaux[this.form.preau_id].fields.reglements_web;

                    let overlayPanel = document.querySelector(".js-overlay-terms");
                    overlayPanel.classList.add('is-active');


                    let closeButtons = document.querySelectorAll('.js-overlay__close button');
                    closeButtons.forEach(button => {
                        button.setAttribute('aria-hidden', 'false');
                        button.removeAttribute('disabled');
                    });

                    setTimeout(() => {
                        document.activeElement.blur();
                        document.querySelector('.js-accessibility-close button').focus();
                    }, 601);

                    //add event listener on scroll js-overlay-terms to enable js-accept-terms button
                    let overlayTerms = document.querySelector('.js-scroll-terms');
                    overlayTerms.addEventListener('scroll', function(e){
                        let acceptTerms = document.querySelector('.js-accept-terms');
                        acceptTerms.removeAttribute('disabled');
                        classRemove(acceptTerms, 'is-disabled');
                    });

                    //add event listener js-accept-terms to check the checkbox of e.target
                    let acceptTerms = document.querySelector('.js-accept-terms');
                    acceptTerms.addEventListener('click', function(e){
                        classRemove(document.querySelector('.is-overlay-active'),'is-overlay-active')
                        classRemove(document.querySelector('.c-overlay-content__item.is-active'),'is-active')
                        app.form.terms = 'true';
                        let datetime = new Date();
                        app.form.terms_date = datetime.toLocaleString('fr-CA', { timeZone: 'America/Toronto' });
                    });
                },
                async fetchPreaux() {
                    return fetch('/wp-json/preaux/v1/fetch?'+Math.random().toString(36).substring(2,7))
                        .then(response => response.json())
                        .then(data => {
                            this.preaux = data;
                            return data;
                        });
                },
                changePreaux() {
                    this.form.dateRange.start = null;
                    this.form.dateRange.end = null;
                    this.dates = '';
                    this.form.terms = false;
                    this.form.options = [];
                    this.setDates();
                },
                setDates() {
                    if(this.hdpkr) this.hdpkr.destroy();

                    let preau = this.preaux[this.form.preau_id];

                    const options = {
                        //only one month shown
                        selectForward: true,
                        minNights: 0,
                        showTopbar: false,
                        startDate: new Date(new Date().getTime() + 3 * 24 * 60 * 60 * 1000),
                        i18n: this.i18n,
                        hoveringTooltip: function(nights, startTime, hoverTime) {
                            return nights+1 + ' journées';
                        },
                        extraDayText: function(date, attributes) {
                            if (attributes.class.includes("datepicker__month-day--valid")) {
                                //Check if date is a weekend
                                let day = new Date(date).getDay();
                                if (day === 5 || day === 6) {
                                    return "<span>"+preau.fields.tarifs.weekend+"$</span>";
                                } else {
                                    return "<span>"+preau.fields.tarifs.semaine+"$</span>";
                                }
                            }
                        }
                    };
                    //check if options.startDate is bigger than the first date of the preau and if options.startDate is smaller than the last date of the preau
                    if(new Date(options.startDate) < new Date(preau.fields.first_date) && new Date(options.startDate) < new Date(preau.fields.last_date)){
                        options.startDate = preau.fields.first_date;
                    }

                    options.endDate = preau.fields.last_date;
                    if(preau.reservations.length > 0){
                        //Get the date from the reservations and add them to the options.unavailableDates
                        let dates = [];

                        preau.reservations.forEach(reservation => {
                            dates.push(reservation.date);
                        });
                        options.disabledDates = dates;
                    }
                    
                    let app = this;
                    let input = this.$refs.datepicker
                    this.hdpkr = new HotelDatepicker(input, options);
                    let hdpkr = this.hdpkr;
                    input.addEventListener(
                        "afterClose",
                        function (event) {
                            app.dates = hdpkr.getValue();
                        },
                        false
                    );
                },
                checkOptionsDisponibility(preau_id, option_id){
                    let preau = this.preaux[preau_id];
                    //find option index
                    let optionIndex = preau.options.findIndex(option => option.id === option_id);
                    let option = preau.options[optionIndex];
                    //Check in option.reservations if the option is available
                    let available = true;
                    let dates = {};
                    if(option.reservations.length > 0){
                        option.reservations.forEach(reservation => {
                            if(new Date(reservation.date).getTime() === new Date(this.form.dateRange.start).getTime()){
                                if(dates[reservation.date]){
                                    dates[reservation.date] += 1;
                                } else {
                                    dates[reservation.date] = 1;
                                }
                            }
                        });
                    }

                    //Check if the options is always available between the start and end date according to the qty
                    let start = new Date(this.form.dateRange.start + 'T00:00:00');
                    let end = new Date(this.form.dateRange.end + 'T00:00:00');
                    let loop = new Date(start);
                    do {
                        //current to Y-m-d watch for the month with 1 digit
                        let current = loop.getFullYear() + '-' + ('0' + (loop.getMonth() +1 )).slice(-2) + '-' + ('0' + loop.getDate()).slice(-2);
                        if(dates[current]){
                            if(dates[current] >= option.meta.qty){
                                available = false;
                            }
                        }
                        loop.setDate(loop.getDate() + 1);
                    } while(loop <= end);

                    return available;

                },
                checkCapacity(){
                    if(!this.form.preau_id){
                        return false;
                    }
                    let preau = this.preaux[this.form.preau_id];
                    let capacity = parseInt(preau.fields.capacity);
                    let total = parseInt(this.form.nb_adulte) + parseInt(this.form.nb_enfant);
                    if(total > capacity){
                        return preau.fields.capacity;
                    }
                    return false;

                },
                async submit(){
                    this.isSubmitting = true;
                    let preaux = await this.fetchPreaux();
                    if(this.form.dateRange.start === null || this.form.dateRange.end === null){
                        alert('Veuillez sélectionner une date');
                        this.isSubmitting = false;
                        return;
                    }

                    if(!this.form.terms){
                        alert('Veuillez accepter les termes et conditions');
                        this.isSubmitting = false;
                        return;
                    }

                    let preau = preaux[this.form.preau_id];
                    //Build array with all the dates between start and end
                    let dates = [];
                    let start = new Date(this.form.dateRange.start);
                    let end = new Date(this.form.dateRange.end);
                    let loop = new Date(start);
                    while(loop <= end){
                        dates.push(new Date(loop));
                        loop.setDate(loop.getDate() + 1);
                    }

                    //Check if the dates are available
                    let available = true;
                    let total = 0;
                    dates.forEach(date => {
                        //Check if date is a weekend
                        let day = new Date(date).getDay();
                        if (day === 5 || day === 6) {
                            total += parseFloat(preau.fields.tarifs.weekend);
                        } else {
                            total += parseFloat(preau.fields.tarifs.semaine);
                        }

                        if(preau.reservations.find(reservation => new Date(reservation.date).getTime() === date.getTime())){
                            available = false;
                        }
                    });

                    let total_options = 0;
                    let options = [];
                    if(this.form.options.length > 0){
                        this.form.options.forEach(option => {
                            if(preau.fields.options[option].per_day){
                                total_options += parseFloat(preau.fields.options[option].price) * dates.length;
                            }else{
                                total_options += parseFloat(preau.fields.options[option].price);
                            }

                            options.push(preau.fields.options[option]);
                        });
                    }

                    let optionsGlobal = [];
                    if(this.form.optionsGlobal.length > 0){
                        this.form.optionsGlobal.forEach(option => {
                            let optionIndex = preau.options.findIndex(opt => opt.id === option);
                            total_options += parseFloat(preau.options[optionIndex].meta.price);

                            optionsGlobal.push(preau.options[optionIndex]);
                        });
                    }

                    if(!available){
                        alert('Les dates sélectionnées ne sont plus disponibles');
                        this.form.dateRange.start = null;
                        this.form.dateRange.end = null;
                        this.dates = '';
                        this.form.options = [];
                        this.isSubmitting = false;
                        return;
                    }

                    let app = this;

                    //If date start and date end are the same
                    let product_name = "";
                    let product_description = "";
                    if(this.form.dateRange.start === this.form.dateRange.end){
                        product_name = 'Location du '+ preau.post_title;
                        product_description = 'Le ' + this.form.dateRange.start;
                    } else {
                        product_name = 'Location du '+ preau.post_title;
                        product_description = 'Du ' + this.form.dateRange.start + " au " + this.form.dateRange.end;
                    }

                    //if options or optionsGlobal are selected add options to the product description
                    if(options.length > 0 || optionsGlobal.length > 0){
                        product_description += " - Services supplémentaires: ";
                        //implode , options title
                        if(options.length > 0){
                            product_description += options.map(option => option.title).join(', ');
                        }

                        if(optionsGlobal.length > 0){
                            if(options.length > 0){
                                product_description += ", ";
                            }
                            product_description += optionsGlobal.map(option => option.title).join(', ');
                        }
                    }

                    let metadata = this.form;
                    metadata.total = total;
                    metadata.total_options = total_options;
                    metadata.options = options;
                    metadata.optionsGlobal = optionsGlobal;
                    metadata.dates = dates;

                    total += total_options;

                    let sku = 'preau_'+ preau.ID;
                    let uniqueId = Math.floor(Math.random() * 1000000) + 1;

                    await window.StereoStoreAddToCart({
                        id: uniqueId,
                        type: 'preau',
                        quantity: 1,
                        name: product_name,
                        description : product_description,
                        price: total,
                        sku: sku,
                        metadata: JSON.stringify(metadata)
                    }).then(function(response){
                        app.isSubmitting = false;
                        window.location.href = '/panier/';
                    });



                }
            },
            watch: {
                dates: function (val) {
                    //Remove spaces and split the string - to get the start and end date
                    let dates = val.split(' - ');
                    this.form.dateRange.start = dates[0];
                    this.form.dateRange.end = dates[1];
                },
                'form.preau_id': function () {
                    this.checkCapacity();
                },
                'form.nb_adulte': function () {
                    this.checkCapacity();
                },
                'form.nb_enfant': function () {
                    this.checkCapacity();
                }
            },
            mounted() {
                this.fetchPreaux();
            },
            ...res,
        });
    }
}
